import ScrollReveal from "@/components/ScrollReveal";
import bedrvLogo from "@/assets/bedrv-logo.png";
import sparkassenstarsLogoAsset from "@/assets/sparkassenstars-logo.jpg.asset.json";
const sparkassenstarsLogo = sparkassenstarsLogoAsset.url;
import papageienparkLogoAsset from "@/assets/papageienpark-logo.png.asset.json";
const papageienparkLogo = papageienparkLogoAsset.url;
import tusHarpenLogo from "@/assets/tus-harpen-logo.jpg";
import ruthLogo from "@/assets/ruth-logo.jpg";
import hausOveneyLogo from "@/assets/haus-oveney-logo.png";
import weconLogo from "@/assets/wecon-logo.jpg";
import cannamedicalLogo from "@/assets/cannamedical-logo.png";
import wjMrLogo from "@/assets/wj-mr-logo.jpg";
import huggiberriesLogo from "@/assets/huggiberries-logo.png";
import teamLimitlessLogo from "@/assets/team-limitless-logo.jpg";
import youmoveLogo from "@/assets/youmove-logo.jpg.asset.json";
import missionNightsLogo from "@/assets/mission-nights-logo.jpg.asset.json";
import cronexLogoAsset from "@/assets/cronex-automobile-logo.png.asset.json";
const cronexLogo = cronexLogoAsset.url;

interface Client {
  name: string;
  logo: string;
  url?: string;
}

const clients: Client[] = [
  { name: "Cronex Automobile", logo: cronexLogo, url: "https://www.cronex-automobile.de" },
  { name: "YouMove Bochum", logo: youmoveLogo.url, url: "https://youmove-bochum.de" },
  { name: "bedrv", logo: bedrvLogo, url: "https://bedriver.it" },
  { name: "VfL SparkassenStars Bochum", logo: sparkassenstarsLogo, url: "https://sparkassenstars.de" },
  { name: "Papageienpark Bochum", logo: papageienparkLogo, url: "https://www.papageienpark-bochum.de" },
  { name: "TuS Harpen", logo: tusHarpenLogo, url: "https://tus-harpen.de" },
  { name: "Ruth Schokoladenwerk", logo: ruthLogo, url: "https://ruth-schokolade.de" },
  { name: "Haus Oveney", logo: hausOveneyLogo, url: "https://oveney.de" },
  { name: "WECON Netzwerk Bochum", logo: weconLogo, url: "https://www.wecon-netzwerk.de/bochum/" },
  { name: "Cannamedical", logo: cannamedicalLogo, url: "https://cannamedical.com" },
  { name: "Wirtschaftsjunioren Mittleres Ruhrgebiet", logo: wjMrLogo, url: "https://wj-mr.de" },
  { name: "Huggiberries", logo: huggiberriesLogo, url: "https://huggiberries.de/" },
  { name: "Team Limitless", logo: teamLimitlessLogo, url: "https://www.instagram.com/limitless.lh/" },
  { name: "Mission Nights", logo: missionNightsLogo.url, url: "https://www.mission-nights.de" },
];

// Triple the list for seamless infinite scroll
const tripled = [...clients, ...clients, ...clients];

const ClientLogos = () => {
  return (
    <section className="py-16 border-t border-border/30 overflow-hidden">
      <div className="container mx-auto px-6 mb-10">
        <ScrollReveal>
          <h3 className="text-center tracking-[0.3em] uppercase text-foreground/85 text-sm">
            Marken, die uns vertrauen
          </h3>
        </ScrollReveal>
      </div>
      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
        {/* Scrolling track */}
        <div className="flex items-center gap-8 animate-logo-scroll w-max">
          {tripled.map((client, i) => {
            const content = (
              <img decoding="async" loading="lazy"
                src={client.logo}
                alt={client.name}
                className="h-full w-auto object-contain max-w-[160px] rounded-md"
              />
            );
            return client.url ? (
              <a
                key={`${client.name}-${i}`}
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-16 px-3 shrink-0 opacity-70 hover:opacity-100 transition-opacity duration-300"
              >
                {content}
              </a>
            ) : (
              <div
                key={`${client.name}-${i}`}
                className="flex items-center justify-center h-16 px-3 shrink-0 opacity-70 hover:opacity-100 transition-opacity duration-300"
              >
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
